import styled from "styled-components";

export const Container = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
  .ant-spin-dot-item {
    background-color: ${({ theme }) => theme.colors.primary};
  }
`;
